import { Router } from "@angular/router";
import { UserService } from "../service/user.service";
import { Injectable } from "@angular/core";
import { HttpService } from "../service/http.service";

@Injectable()
export class ConnectedGuardService {

    constructor(
        private http: HttpService,
        private userService: UserService,
        private router: Router
    ){}


    // canActivate(){
    //     if(this.userService.hasToken()){
    //         return true;
    //     }
    //     else {
    //         this.router.navigateByUrl("/login");
    //         return false;
    //     }
    // }
}